module.exports = __webpack_public_path__ + "static/workerHomeBanner-6a7fc340c5dac6baefd0c78131e8a935.png";